import React, { useRef } from 'react';
import './Screenshots.css';

// Import all screenshots
import ss1 from '../../assets/images/ss1.jpg';
import ss2 from '../../assets/images/ss2.jpg';
import ss3 from '../../assets/images/ss3.jpg';
import ss4 from '../../assets/images/ss4.jpg';
import ss5 from '../../assets/images/ss5.jpg';
import ss6 from '../../assets/images/ss6.jpg';
import ss7 from '../../assets/images/ss7.jpg';
import ss8 from '../../assets/images/ss8.jpg';
import ss9 from '../../assets/images/ss9.jpg';
import ss10 from '../../assets/images/ss10.jpg';

const screenshots = [
  { id: 1, alt: 'AInstein App Screenshot 1', src: ss1 },
  { id: 2, alt: 'AInstein App Screenshot 2', src: ss2 },
  { id: 3, alt: 'AInstein App Screenshot 3', src: ss3 },
  { id: 4, alt: 'AInstein App Screenshot 4', src: ss4 },
  { id: 5, alt: 'AInstein App Screenshot 5', src: ss5 },
  { id: 6, alt: 'AInstein App Screenshot 6', src: ss6 },
  { id: 7, alt: 'AInstein App Screenshot 7', src: ss7 },
  { id: 8, alt: 'AInstein App Screenshot 8', src: ss8 },
  { id: 9, alt: 'AInstein App Screenshot 9', src: ss9 },
  { id: 10, alt: 'AInstein App Screenshot 10', src: ss10 },
];

const Screenshots: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (!containerRef.current) return;
    
    const container = containerRef.current;
    const scrollAmount = container.clientWidth * 0.8; // Scroll 80% of container width
    
    container.scrollBy({
      left: direction === 'right' ? scrollAmount : -scrollAmount,
      behavior: 'smooth'
    });
  };

  return (
    <div className="screenshots-horizontal">
      <button 
        className="nav-arrow left-arrow" 
        onClick={() => scroll('left')}
        aria-label="Previous screenshot"
      >
        <i className="fas fa-chevron-left"></i>
      </button>
      
      <div className="screenshots-track" ref={containerRef}>
        <div className="screenshots-inner">
          {screenshots.map((screenshot) => (
            <div key={screenshot.id} className="phone-mockup">
              <img 
                src={screenshot.src} 
                alt={screenshot.alt}
                className="screenshot-image"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
      
      <button 
        className="nav-arrow right-arrow" 
        onClick={() => scroll('right')}
        aria-label="Next screenshot"
      >
        <i className="fas fa-chevron-right"></i>
      </button>
    </div>
  );
};

export default Screenshots;
